import { render, staticRenderFns } from "./speedchat.vue?vue&type=template&id=40869bcf&scoped=true&lang=pug&"
import script from "./speedchat.vue?vue&type=script&lang=js&"
export * from "./speedchat.vue?vue&type=script&lang=js&"
import style0 from "./speedchat.vue?vue&type=style&index=0&id=40869bcf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40869bcf",
  null
  
)

export default component.exports